var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-file-input',{attrs:{"counter":"","show-size":"","truncate-length":"25","placeholder":"Open CSV File","accept":".csv"},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }